import { IKnmStatusSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmStatusSelectOption';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';

import { IPublishRulesErpUnscheduledForm } from '../interfaces/IPublishRulesErpUnscheduledForm';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { getPublishDeadlineOptions } from './getPublishDeadlineOptions';
import { PublishRulesDeadlineModesEnum } from '../enums/publishRulesDeadlineModesEnum';

export const getPublishRulesErpUnscheduledFormInitialValues: (
  treeItem: IPublishRulesTreeItem,
  erpStatusesSelectOptions?: IKnmStatusSelectOption[],
) => IPublishRulesErpUnscheduledForm = (treeItem, erpStatusesSelectOptions) => {
  const publishDeadlineImmediatelyOption = getPublishDeadlineOptions().find(
    item => item.value === PublishRulesDeadlineModesEnum.IMMEDIATELY,
  );

  /**
   * Необходимый статус "В процессе проведения",
   * его нет в enum, но благодаря какой-то магии с подменой имен старых
   * на новые в справочнике, отображается нужный статус
   * */
  const waitingCarryOutKnmStatusOption = erpStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_WAITING_CARRY_OUT,
  );

  switch (treeItem.category) {
    case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS:
      return {
        uponAttainingStatus: waitingCarryOutKnmStatusOption ? [waitingCarryOutKnmStatusOption] : undefined,
        publishDeadline: publishDeadlineImmediatelyOption,
        additionalSettings: [],
      };
    case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_DP:
    case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_KZ:
    case PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_VP:
    default:
      return { uponAttainingStatus: undefined, publishDeadline: undefined, additionalSettings: [] };
  }
};
